import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var linkComponentName = 'QuantumLink';
export function getLinkUtilityClass(slot) {
    return generateUtilityClass(linkComponentName, slot);
}
export var linkClasses = generateUtilityClasses(linkComponentName, ['root', 'icon', 'startIcon', 'endIcon']);
